import React, { useState,useRef,useEffect } from 'react';
import styles from './SimcView.scss';
import classNames from 'classnames/bind';

// import {NumericFormat} from 'react-number-format';

import {useNavigate} from 'react-router-dom';

import { calcDamage, bodyUpList, powerUpList } from 'util/damageCalc';

import Adsense970250 from 'components/adsense/Adsense970250';
import Adsense300250 from 'components/adsense/Adsense300250';

const cx = classNames.bind(styles);

const SimcView = ({setStat, myStat, currSelWeapon}) => {
  const navigate = useNavigate();

  const {con, ski, itemDmg, itemCri, achDmg, rimtDmg, isPara, isDoping, weaponType, monSize, monType, selSkillSeq} = myStat;
  const {
    weaponSkillList,
    inven_cri,
    head_atk_rt,
    inven_dmg,
    totalDmg
  } = calcDamage({myStat, currSelWeapon});

  // const {
  //   normalDmg,
  //   normalDmgFire,
  //   criDmg,
  //   criDmgFire,
  //   headDmg,
  //   headDmgFire
  // } = totalDmg;

  // 허수아비 템플릿
  const CUSTOM_DUMMY_STORAGE_KEY = 'simc_custom_dummy';

  const DUMMY_LIST = [
    { id: 'easy', name: '초급 허수아비', hp: 1_000_000, reward: 1_000_000 },
    { id: 'normal', name: '중급 허수아비', hp: 100_000_000, reward: 100_000_000 },
    { id: 'hard', name: '고급 허수아비', hp: 1_000_000_000, reward: 1_000_000_000 },
  ];

  const [dummy, setDummy] = useState(DUMMY_LIST[0]);
  const [dummyHp, setDummyHp] = useState(DUMMY_LIST[0].hp);
  const [earnedReward, setEarnedReward] = useState(0);
  const [killedCount, setKilledCount] = useState(0);
  const [customDummy, setCustomDummy] = useState({
    id: 'custom',
    name: '사용자 허수아비',
    hp: 0,
    reward: 0,
  });
  const [isCustomEnabled, setIsCustomEnabled] = useState(false);
  const [showCustomForm, setShowCustomForm] = useState(false);

  const [customHpInput, setCustomHpInput] = useState('');
  const [customRewardInput, setCustomRewardInput] = useState('');

  const selectDummy = (d) => {
    setDummy(d);
    setDummyHp(d.hp);
    setEarnedReward(0);
    setKilledCount(0);
    setBattleLogs([]);
    setTotalDamage(0);
    // 🔥 커스텀 입력 UI 닫기
    setShowCustomForm(false);
  };

  const [battleLogs, setBattleLogs] = useState([]);
  const [turn, setTurn] = useState(0);
  const [totalDamage, setTotalDamage] = useState(0);
  const [startTime, setStartTime] = useState(null);
  const [isRunning, setIsRunning] = useState(false);
  const timerRef = useRef(null);
  const randBetween = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };
  
  const [battleTick, setBattleTick] = useState(0);
  const [isFireActive, setIsFireActive] = useState(false);
  const [fireRemainSec, setFireRemainSec] = useState(0);
  const [fireText, setFireText] = useState('대기');

  // const isSuccess = (percent) => {
  //   return Math.random() * 100 < percent;
  // };
  
  const {currItem, currItemOption} = currSelWeapon;
  const {ITEM_NM, CLYN, ITEM_DTL_DV, SPEED, CTYPE, STYPE1} = currItem;
  const {powerUp, bodyUp} = currItemOption;
  const tripple = ITEM_DTL_DV == '저격소총' || ITEM_DTL_DV == '샷건' ? 3 : 1;
  let spd = SPEED * tripple;
  spd = CTYPE === '1' && STYPE1 === '2' ? 170 : spd;
  const travelY = spd * 0.25 + 20;
  const travelY2 = spd * 0.35 + 20;
  const spreadX =
  spd <= 200
    ? 6
    : 6 + Math.pow((spd - 200) / 400, 1.3) * 14;
  const offsetX =
  (Math.random() * 2 - 1) * spreadX;

  const countRt = 50;
  const headShotRt = 95;

  const FIRE_DELAY = 30;   // 발동 대기
  const FIRE_DURATION = 14; // 유지 시간
  const FIRE_CYCLE = FIRE_DELAY + FIRE_DURATION;

  // const battleSec = startTime
  //   ? Math.floor((Date.now() - startTime) / 1000)
  //   : 0;
  // const fireCyclePos = battleSec % FIRE_CYCLE;
  // // const isFireActive =
  // //   fireCyclePos >= FIRE_DELAY &&
  // //   fireCyclePos < FIRE_DELAY + FIRE_DURATION;
  // let fireRemainSec = 0;
  // let fireText = '대기';

  // if (isFireActive) {
  //   fireRemainSec = FIRE_DELAY + FIRE_DURATION - fireCyclePos;
  //   fireText = `발화중 (${fireRemainSec}초)`;
  // } else {
  //   fireRemainSec = FIRE_DELAY - fireCyclePos;
  //   fireText = `대기 (${fireRemainSec}초)`;
  // }

  const fireActiveRef = useRef(false);

  const calcOneHit = () => {
    let dmg;
    let type = 'normal';

    const isCri = Math.random() * 100 < inven_cri;
    const isFire = fireActiveRef.current;
  // console.log(isFire);
    const dmgTable = isFire
      ? {
          normal: totalDmg.normalDmgFire,
          cri: totalDmg.criDmgFire,
          head: totalDmg.headDmgFire
        }
      : {
          normal: totalDmg.normalDmg,
          cri: totalDmg.criDmg,
          head: totalDmg.headDmg
        };

    const headRt = CTYPE === '1' && STYPE1 === '2' ? countRt : headShotRt;

    if (isCri) {
      const isHead = Math.random() * 100 < headRt;
      if (isHead) {
        dmg = randBetween(dmgTable.head.min, dmgTable.head.max);
        type = 'head';
      } else {
        dmg = randBetween(dmgTable.cri.min, dmgTable.cri.max);
        type = 'cri';
      }
    } else {
      dmg = randBetween(dmgTable.normal.min, dmgTable.normal.max);
    }

    return { dmg, type };
  };


  const doAttack = () => {
    const { dmg, type } = calcOneHit();

    setBattleLogs(prev => {
      const next = [{ dmg, type, id: Date.now() }, ...prev];
      return next.slice(0, 8);
    });

    setTotalDamage(prev => prev + dmg);

    //잡을때마다 포상
    // setDummyHp(prevHp => {
    //   let nextHp = prevHp - dmg;
    //   return nextHp <= 0 ? 0 : nextHp;
    // });

    //때릴때마다포상
    setDummyHp(prevHp => {
      const actualDmg = Math.min(prevHp, dmg);

      // 🔥 데미지 비율만큼 실시간 보상 증가
      const rewardGained =
        (actualDmg / dummy.hp) * dummy.reward;

      setEarnedReward(prev => prev + rewardGained);

      return prevHp - actualDmg;
    });
  };

  useEffect(() => {
    if (dummyHp > 0) return;

      // 🔥 여기서만 1번 실행됨
      setKilledCount(prev => prev + 1);

      // 보상은 정확히 1마리 기준으로
      setEarnedReward(prev => prev + dummy.reward);

      // 새 허수아비 스폰
      setDummyHp(dummy.hp);
  }, [dummyHp, dummy.hp, dummy.reward]);

  useEffect(() => {
    const saved = localStorage.getItem(CUSTOM_DUMMY_STORAGE_KEY);

    if (!saved) return;

    try {
      const parsed = JSON.parse(saved);

      if (parsed.hp > 0 && parsed.reward >= 0) {
        setCustomDummy(parsed);
        setIsCustomEnabled(true);
      }
    } catch (e) {
      // 파싱 실패 시 무시
      console.warn('사용자 허수아비 로드 실패');
    }
  }, []);
  useEffect(() => {
    if (!startTime) return;

    const battleSec = Math.floor((Date.now() - startTime) / 1000);
    const fireCyclePos = battleSec % FIRE_CYCLE;

    const active =
      fireCyclePos >= FIRE_DELAY &&
      fireCyclePos < FIRE_DELAY + FIRE_DURATION;

    setIsFireActive(active);
    fireActiveRef.current = active; // 🔥 핵심

    if (active) {
      const remain = FIRE_DELAY + FIRE_DURATION - fireCyclePos;
      setFireText(`발화중 (${remain}초)`);
    } else {
      const remain = FIRE_DELAY - fireCyclePos;
      setFireText(`대기 (${remain}초)`);
    }
  }, [battleTick, startTime]);



  const handleStart = () => {
    if (isRunning) return;

    setIsRunning(true);
    setStartTime(Date.now());

    // 🔥 시간 갱신용 tick
    setBattleTick(0);
    const tickTimer = setInterval(() => {
      setBattleTick(prev => prev + 1);
    }, 1000);

    const interval = 60000 / (spd); // ms

    // const animDuration = 1200; // ms
    // const visibleCount = animDuration / attackInterval;

    doAttack();

    // timerRef.current = setInterval(() => {
    //   doAttack();
    // }, interval);
    timerRef.current = {
      attack: setInterval(doAttack, interval),
      tick: tickTimer,
    };
  };
  // const handleBattleTurn = () => {
  //   const nextTurn = turn + 1;
  //   let dmg;
  //   let resultType = '일반';

  //   // 1. 크리 판정
  //   const isCri = isSuccess(inven_cri);

  //   if (isCri) {
  //     // 2. 헤드샷 판정 (90%)
  //     const isHead = isSuccess(90);

  //     if (isHead) {
  //       dmg = randBetween(totalDmg.headDmg.min, totalDmg.headDmg.max);
  //       resultType = '헤드샷';
  //     } else {
  //       dmg = randBetween(totalDmg.criDmg.min, totalDmg.criDmg.max);
  //       resultType = '크리티컬';
  //     }
  //   } else {
  //     dmg = randBetween(totalDmg.normalDmg.min, totalDmg.normalDmg.max);
  //     resultType = '일반';
  //   }

  //   const log = {
  //     turn: nextTurn,
  //     type: resultType,
  //     dmg
  //   };

  //   setTurn(nextTurn);
  //   setBattleLogs(prev => [log, ...prev]);
  // };

  const handleReset = () => {
    if (timerRef.current?.attack)
      clearInterval(timerRef.current.attack);
    if (timerRef.current?.tick)
      clearInterval(timerRef.current.tick);

    timerRef.current = null;

    setBattleLogs([]);
    setTotalDamage(0);
    setStartTime(null);
    setIsRunning(false);

    setDummyHp(dummy.hp);
    setEarnedReward(0);
    setKilledCount(0);

    setBattleTick(0);
    setIsFireActive(false);
    setFireText('대기');
  };



  const dps = startTime
    ? Math.floor(
        totalDamage / ((Date.now() - startTime) / 1000)
      )
    : 0;

  const battleTimeSec = startTime
    ? Math.floor((Date.now() - startTime) / 1000)
    : 0;

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${String(s).padStart(2, '0')}`;
  };


  let titleName = ITEM_NM === undefined ? '' : 
  (CLYN === 'Y' ? powerUpList[powerUp].titleClName + ' ' + bodyUpList[bodyUp].name + ' ' + ITEM_NM.substr(4) : 
  powerUpList[powerUp].titleName + ' ' + bodyUpList[bodyUp].name + ' ' + ITEM_NM);
  // titleName = bodyUp > 0 ? titleName + ' '+ ITEM_NM.substr(4): titleName;

  const useSkill = weaponSkillList[selSkillSeq] ?? false;

  const hpPercent = Math.max(
    0,
    Math.floor((dummyHp / dummy.hp) * 100)
  );

  const formatToEok = (value) => {
    if (value < 100_000_000) {
      return value.toLocaleString();
    }

    const eok = value / 100_000_000;
    return `${eok.toFixed(2)}억`;
  };

  const formatToMan = (value) => {
    if (value < 10_000) return value.toLocaleString();
    return `${Math.floor(value / 10_000).toLocaleString()}만`;
  };

  const formatToManOrEok = (value) => {
  if (value >= 100_000_000) {
    const eok = value / 100_000_000;
    return `${eok % 1 === 0 ? eok : eok.toFixed(1)}억`;
  }

  if (value >= 10_000) {
    return `${Math.floor(value / 10_000).toLocaleString()}만`;
  }

  return value.toLocaleString();
};


  return (
   <div className={cx('simc')}>
      {/* 헤더 */}
      <div className={cx('simc-header')}>
        <h2>사냥 시뮬레이션</h2>
        <p>현재 무기 · 스탯 · 스킬 세팅으로 전투를 진행합니다</p>
      </div>
      <Adsense970250/>
      {/* 전투 요약 */}
      <div className={cx('summary-card')}>
        <div className={cx(`summary-item up${bodyUpList[bodyUp].value}`)}>
          <span className={cx('label')}>무기</span>
          <span className={cx('value')}>{titleName}</span>
        </div>

        <div className={cx('summary-item damage')}>
          <span className={cx('label')}>공격력(인벤창)</span>
          <span className={cx('value')}>{inven_dmg.toLocaleString()}</span>
        </div>

        <div className={cx('summary-item cri')}>
          <span className={cx('label')}>치명 확률</span>
          <span className={cx('value')}>{inven_cri}%</span>
        </div>

        <div className={cx('summary-item head')}>
          <span className={cx('label')}>헤드샷 배율</span>
          <span className={cx('value')}>{head_atk_rt}x</span>
        </div>

        <div className={cx('summary-item spped')}>
          <span className={cx('label')}>무기공속</span>
          <span className={cx('value')}>
            {/* {spd+','}{`-${travelY}px,`}{`-${travelY2}px/,`} */}
            {SPEED+'/분'}
          </span>
        </div>
        <div className={cx('summary-item spped')}>
          <span className={cx('label')}>실제공속</span>
          
          <span className={cx('value')}>
            {/* {spd+','}{`-${travelY}px,`}{`-${travelY2}px/,`} */}
            {spd+'/분'}
          </span>
        </div>
        <div className={cx('summary-item skill')}>
          <span className={cx('label')}>사용스킬 (사용중..)</span>
          {/* {JSON.stringify(useSkill)} */}
            
            {useSkill.seq != 0 ? 
            <span className={cx('value skill-badge active')}>
              <img className="skill-icon" src={useSkill.img} alt="" />
              {`${useSkill.name}`}
            </span> :
            <span className={cx('value')}>없음</span>
            }
        </div>
        <div className={cx('summary-item fire')}>
          <span className={cx('label')}>발화상태(마스터토이)</span>
          <span className={cx('value')}>
            {fireText}
          </span>
        </div>
      </div>
      
      <p className={cx('summary-note')}>
        ※ 트샷·트저(트리플 무기)는 무기를 3개 사용하며
        실제공속은 무기 공속 ×3으로 계산됩니다.<br/>
        근접무기의 실제공속은 스테로이드가 사용된 170으로 고정되어 있습니다.
      </p>
      <p className={cx('summary-note')}>
        ※ 원거리 무기는 크리티컬 시 {headShotRt}% 확률로 헤드샷,<br/>
        근거리 무기는 크리티컬 시 {countRt}% 확률로 카운터가 발동한다는 가정으로 계산됩니다.
        <button
          type="button" className={cx('edit-link')}
          onClick={() => navigate(-1)}>세팅 수정하러 가기</button>
      </p>
            
      {/* 허수아비 영역 */}
      <div className={cx('dummy-area')}>
        {/* <div className={cx('dummy-select')}>
          {DUMMY_LIST.map(d => (
            <button
              key={d.id}
              className={cx(
                'dummy-btn',
                dummy.id === d.id && 'active'
              )}
              onClick={() => selectDummy(d)}
            >
              {d.name}
            </button>
          ))}
        </div> */}
        <div className={cx('dummy-select')}>
          {DUMMY_LIST.map(d => (
            <button
              key={d.id}
              className={cx(
                'dummy-btn',
                dummy.id === d.id && 'active'
              )}
              onClick={() => selectDummy(d)}
            >
              <div className={cx('dummy-name')}>
                {d.name}
              </div>

              <div className={cx('dummy-meta')}>
                <span>체력 {formatToManOrEok(d.hp)}</span>
                <span>포상 {formatToManOrEok(d.reward)}</span>
              </div>
            </button>
          ))}

          {/* 사용자정의 허수아비 버튼 */}
          <button
            className={cx(
              'dummy-btn',
              'custom',
              dummy.id === 'custom' && 'active',
              !isCustomEnabled && 'disabled'
            )}
            onClick={() => {
              // if (!isCustomEnabled) { //한번만연다.
                setShowCustomForm(true);
              // } else {
                // selectDummy(customDummy);
              // }
            }}
          >
            <div className={cx('dummy-name')}>커스텀 허수아비</div>
            {isCustomEnabled ? (
              <div className={cx('dummy-meta')}>
                <span>체력 {formatToManOrEok(customDummy.hp)}</span>
                <span>포상 {formatToManOrEok(customDummy.reward)}</span>
              </div>
            ) : (
              <div className={cx('dummy-meta')}>
                <span>설정 필요</span>
              </div>
            )}
          </button>

          
        </div>
{/* {JSON.stringify(totalDmg)} */}
        {showCustomForm && (
          <div className={cx('custom-dummy-form')}>
            <div className={cx('form-row')}>
              <label>체력</label>
              <input
                type="number"
                value={customHpInput}
                onChange={e => setCustomHpInput(e.target.value)}
                onFocus={e => e.target.select()}
                placeholder="예: 50000000"
              />
            </div>

            <div className={cx('form-row')}>
              <label>포상</label>
              <input
                type="number"
                value={customRewardInput}
                onChange={e => setCustomRewardInput(e.target.value)}
                onFocus={e => e.target.select()}
                placeholder="예: 50000000"
              />
            </div>

            <button
              className={cx('confirm-btn')}
              onClick={() => {
                const hp = Number(customHpInput);
                const reward = Number(customRewardInput);

                if (hp > 0 && reward >= 0) {
                  const nextDummy = {
                    id: 'custom',
                    name: '사용자 허수아비',
                    hp,
                    reward,
                  };

                  // 🔥 저장
                  localStorage.setItem(
                    CUSTOM_DUMMY_STORAGE_KEY,
                    JSON.stringify(nextDummy)
                  );

                  setCustomDummy(nextDummy);
                  setIsCustomEnabled(true);
                  setShowCustomForm(false);

                  selectDummy(nextDummy);
                }
              }}
            >
              확인
            </button>
            {/* <button
              className={cx('confirm-btn')}
              onClick={() => {
                localStorage.removeItem(CUSTOM_DUMMY_STORAGE_KEY);
                setIsCustomEnabled(false);
                setCustomDummy({
                  id: 'custom',
                  name: '사용자 허수아비',
                  hp: 0,
                  reward: 0,
                });
              }}
            >
              사용자 허수아비 초기화
            </button> */}
          </div>
        )}

        <div className={cx('dummy-bar')}>
          
          <div className={cx('dummy-rule')}>
            {`피부: ${monType} · 크기: ${monSize}`}
          </div>
          <div
            className={cx('dummy-hp')}
            style={{
              width: `${(dummyHp / dummy.hp) * 100}%`
            }}
          />
        </div>

        <div className={cx('dummy-info')}>
          <span>
            HP {dummyHp.toLocaleString()} / {dummy.hp.toLocaleString()}
            <span className={cx('hp-percent')}>
              {' '}({hpPercent}%)
            </span>
          </span>
        </div>
      </div>

      {/* 전투 영역 */}
      <div className={cx('battle-area')}>
        <div className={cx('battle-time')}>
          전투 시간 {formatTime(battleTimeSec)}
        </div>
        <div className={cx('battle-row')}>
          <div className={cx('damage-stream')}>
            <div className={cx('battle-damage-area')}>
            {battleLogs.map(log => (
              <div
                key={log.id}
                className={cx(
                  'damage-item',
                  log.type === 'cri' && 'cri',
                  log.type === 'head' && 'head',
                  isFireActive && 'fire' 
                )}

                style={{
                  transform: `translateX(calc(-50% + ${offsetX}px))`,
                  '--travelY': `-${travelY}px`,
                  '--travelY2': `-${travelY2}px`
                }}
              >{log.dmg.toLocaleString()}</div>
            ))}
            </div>
          </div>
          <div className={cx('battle-ad-area')}>
            <Adsense300250 />
          </div>
        </div>

        <div className={cx('battle-stats')}>
          <div>DPS: {dps.toLocaleString()}</div>
          <div style={{ color: '#ff5252' }}>누적 데미지: {formatToEok(totalDamage)}</div>
          <div style={{ color: '#19aa47ff' }}>
            누적 포상: {formatToEok(Math.floor(earnedReward))}
          </div>
          <div style={{ color: '#94a3b8' }}>
            처치한 허수아비: {killedCount.toLocaleString()}마리
          </div>
        </div>
      </div>

      {/* 액션 */}
      <div className={cx('action-area')}>
        <div className={cx('action-buttons')}>
          <button
            className={cx('start-btn')}
            onClick={handleStart}
          >
            사냥 시작
          </button>

          <button
            className={cx('reset-btn')}
            onClick={handleReset}
          >
            초기화
          </button>
        </div>

        <button
          type="button" className={cx('edit-link')}
          onClick={() => navigate(-1)}>세팅 수정하러 가기</button>
      </div>
    </div>
  )
}

export default SimcView;